<div class="details document-details">
  <div class="product-description">
    <label class="product-code my-2" [innerHtml]="product.code| searchHighlight:searchQuery"></label>
    @if (isLoggedIn) {
      @if (tooltip) {
        <span class="tooltip-AddtoFavorites">{{ 'common.text_favorite_to_add' | cxTranslate }} </span>
      }
      <!-- <span (click)="addfav = !addfav" (mouseenter)="tooltip = true" (mouseleave)="tooltip = false">
        @if (tooltip) {
          1
<img (click)="SubscribeDoc(product)" [attr.src]="
            tooltip ? '/icons/icon_star_active.svg' : '/icons/icon_star.svg'
          " alt="" class="icon-star" />
        }
        @if (!tooltip) {
          2
<img [attr.src]="
            addfav ? '/icons/icon_star_active.svg' : '/icons/icon_star.svg'
          " alt="" class="icon-star" />
        }
      </span> -->
          <span (mouseenter)="onHover(true)" (mouseleave)="onHover(false)" (click)="onMobileClick($event, product)">
            @if (tooltip) {
              <img
                (click)="SubscribeDoc(product); $event.stopPropagation()"
                [attr.src]="'/icons/icon_star_active.svg'"
                alt=""
                class="icon-star"
              />
            }
            @if (!tooltip) {
              <img
                (click)="SubscribeDoc(product); $event.stopPropagation()"
                [attr.src]="addfav ? '/icons/icon_star_active.svg' : '/icons/icon_star.svg'"
                alt=""
                class="icon-star"
              />
            }
          </span>
    }
    <div class="doc-desc mb-2 pdp-document-tab-title" [innerHTML]="product?.description| searchHighlight:searchQuery">
    </div>
    <div class="doc-text category"
      [innerHTML]="(product.productCategory && product.productCategory.length)?  (product?.productCategory[0]| searchHighlight:searchQuery) : ''">
    </div>
    <div class="doc-text mb-2" [innerHTML]="product?.docType| searchHighlight:searchQuery"></div>
    <div class="doc-text mb-2">{{ 'common.document_text_language' | cxTranslate }}<span
    [innerHTML]="product.language"></span></div>
    <div class="doc-text mb-2">{{ 'common.document_text_revision' | cxTranslate }}<span
    [innerHTML]="product.revision"></span></div>
    <div class="doc-text mb-2">{{ 'common.document_text_releaseDate' | cxTranslate }}<span
    [innerHTML]="product.releaseDate"></span></div>
  </div>
  @if (product?.fileName?.toLowerCase()?.includes('.url')) {
    <div class="download-btn-outer">
      <div class="download-btn-outer">
        <a href="{{product.url}}" target="_blank" class="btn button btn-primary-new btn-launch-new" rel="noopener">
          {{ 'common.document_video_launch_btn' | cxTranslate }}
          <img src="/icons/link-grey.svg" class="icon-right" alt="video launch" />
        </a>
      </div>
    </div>
  } @else {
    <div class="download-btn-outer">
      <a class="btn btn-primary-new" (click)="callApi(product)" target="_blank">
        {{ 'common.document_download_btn' | cxTranslate }}
        <img src="/icons/link-grey.svg" class="icon-right" alt="document download" />
      </a>
    </div>
  }
</div>